export const TYPES_MAP = {
  false: {
    name: 'No individual bookings allowed',
    style: 'info',
  },
}
